import { create } from 'zustand';

/**
 * État de connexion du socket temps réel, exposé aux hooks de requête pour
 * gater leur polling « filet de sécurité » (cf. fallbackRefetchInterval) :
 * connecté → on s'appuie sur le socket, déconnecté → on re-fetch périodiquement.
 *
 * Optimiste par défaut (`true`) : on ne déclenche le polling qu'après une vraie
 * perte de connexion signalée par useSocketSync, pas pendant le bref établissement
 * initial du socket.
 */
type SocketState = {
  connected: boolean;
  setConnected: (v: boolean) => void;
};

export const useSocketStore = create<SocketState>((set) => ({
  connected: true,
  setConnected: (v) => set({ connected: v }),
}));
